
<div container>
  <meta-title i18n>
    אימות דו שלבי
  </meta-title>

  <ui-error [state]="loadState"></ui-error>

  <section *visible="loadState.isCompleted">
    <form
      [formGroup]="form"
      novalidate
      autocomplete="off"
      (submit)="validate()"
    >
      <mat-form-field appearance="fill">
        <mat-label i18n>
          קוד אימות
        </mat-label>

        <input matInput
          type="text"
          required
          formControlName="code"
          [autofocus]="loadState"
          maxlength="10">

        <mat-error i18n>
          אנא הזן קוד אימות תקין
        </mat-error>
      </mat-form-field>

      <ui-progress-button
        color="primary"
        [disabled]="form.invalid"
        [state]="validateState"
        i18n>
        {validateState.value, select,
          inProcess {מאמת קוד}
          other {אימות קוד}}
      </ui-progress-button>&nbsp;

      <button mat-raised-button
        type="button"
        color="pirmary"
        (click)="reset()"
        i18n>
        ביטול
      </button>

      <ui-alert type="warning" *visible="validateState.error?.isInvalidModel || validateState.error?.isVerificationFailed">
        <div ui-body i18n>
          קוד האימות אינו נכון
        </div>
      </ui-alert>

      <ui-error [state]="validateState"
        [ignoreList]="[400,401]">
      </ui-error>
    </form>

    <mat-divider></mat-divider>

    <section>
      <p class="mt-5" i18n>
        לאחר 5 נסיונות התחברות כושלים,<br/>
        המערכת תחסום אותך אוטומטית ל-20 דקות.
      </p>
    </section>
  </section>
</div>
